export default "__VITE_ASSET__df519de4__"